/* global axios */
// A fila do menu lateral: quantos clientes aguardam um atendente (o número em
// "Aguardando" e no ícone de Conversas), os times que limitam a fila desta
// pessoa (recurso "fila_por_time" da empresa) e o time da IA ("Com a IA"). Relida
// quando as conversas da tela mudam (atribuição, status, conversa nova chegam
// pelo tempo real) e, por garantia, a cada minuto.
import { ref, computed, watch, onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import { useAccount } from 'dashboard/composables/useAccount';
import { debounce } from '@chatwoot/utils';

const UM_MINUTO = 60 * 1000;

const fila = ref({ aguardando: 0, times: null, time_ia_id: null });

// O time da IA da empresa (null sem IA ligada): a lista dele é "Com a IA".
export const timeDaIa = computed(() => fila.value.time_ia_id);

// A lista "Aguardando" no navegador (conversa nova chega pelo tempo real) com o
// mesmo limite de times que o servidor aplica na busca.
export const filtraAguardando = conversas => {
  const { times } = fila.value;
  return times
    ? conversas.filter(conversa => times.includes(conversa.meta?.team?.id))
    : conversas;
};

// Só o menu lateral chama: carrega e mantém a fila em dia.
export const useFila = () => {
  const store = useStore();
  const { accountId } = useAccount();

  const carrega = async () => {
    if (!accountId.value) return;
    try {
      const { data } = await axios.get(
        `/api/v1/accounts/${accountId.value}/neuxs/fila`
      );
      fila.value = data;
    } catch {
      // Sem o número o menu continua funcionando; tenta de novo no próximo aviso.
    }
  };
  const recarrega = debounce(carrega, 1500);

  // O que muda a fila: quem está atribuído e o status de cada conversa.
  const assinatura = computed(() =>
    store.getters.getAllConversations
      .map(c => `${c.id}:${c.status}:${c.meta?.assignee?.id || ''}`)
      .join(',')
  );
  watch(assinatura, recarrega);
  watch(accountId, carrega);

  let relogio;
  onMounted(() => {
    carrega();
    relogio = setInterval(carrega, UM_MINUTO);
  });
  onUnmounted(() => clearInterval(relogio));

  return fila;
};
